import React, { useEffect, useState } from "react";
import {
  adminupdateplayer,
  agecatactivelist,
  profileagecatlist,
  schoollist,
  sportsactivelist,
  viewprofile,
} from "../../../../services/superadmin";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { classlist, schoollistmaster } from "../../../../services/master";
import {
  cityplayerview,
  cityupdateplayer,
  crmagecatelist,
  crmprofileagecatelist,
  crmsportslist,
  schoolactivelistcityreg,
} from "../../../../services/cityregionaladmin";
import { schoolviewplayer, schupdateplayer } from "../../../../services/schoolhead";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import {
  playerformdelete,
  playerformlist,
  playerformupload,
  playersportcatedelete,
  playersportcatelist,
  playersportcateupload,
} from "../../../../services/common";
import { Col, Modal, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";
import { coachplayerview, coachupdateplayer } from "../../../../services/coach";

export const EditPlayer = () => {
  const { id } = useParams();
  const [fname, setFName] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDOB] = useState("");
  const [email, setEmail] = useState("");
  const [mobno, setMobNo] = useState("");
  const [clas, setClass] = useState("");
  const [section, setSection] = useState("");
  const [status, setStatus] = useState(0);
  const [schid, setSchool] = useState("");
  const [uname, setUser] = useState("");
  const [father, setFather] = useState("");

  const [pstatus, setPStatus] = useState("1");
  const [doj, setDOJ] = useState("");

  const [schlist, setSchList] = useState([]);
  const [sclist, setClassList] = useState([]);

  const [sport, setSport] = useState("");
  const [sportid, setSportId] = useState("");
  const [sportpos, setSportPos] = useState("");
  const [stufq, setStuFQ] = useState("");
  const [stunfq, setStuNFQ] = useState("");

  const [submitted, setSubmitted] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();

  // const [slist, setSList] = useState([]);
  // const [dist, setDist] = useState("");
  // const [dlist, setDList] = useState([]);
  // const [city, setCity] = useState("");
  // const [clist, setCList] = useState([]);
  // const [photo, setPhoto] = useState("");
  // const [addr, setAddr] = useState("");
  // const [pin, setPin] = useState("");
  // const [lname, setLName] = useState("")
  // const [state, setState] = useState("");

  function LetterOnly(eve) {
    if (/^[a-zA-Z\s]*$/.test(eve.key)) {
      return true;
    } else {
      eve.preventDefault();
      return false;
    }
  }
  function onPasteLetter(e) {
    const str = e.clipboardData.getData("Text");
    const newStr = str.replace(/[+-.]/g, "");
    if (str !== newStr) {
      e.preventDefault();
    }
  }

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setMobNo(e.target.value);
    }
  };

  const [photoerror, setPhotoError] = useState("");
  const [photourl, setPhotoUrl] = useState("");
  const [photo, setPhoto] = useState("");

  function photofile(event) {
    setPhotoError("");
    setPhoto("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setPhotoUrl(URL.createObjectURL(event.target.files[0]));
        setPhoto(event.target.files[0]);
      } else {
        setPhotoError("Photograph should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setPhotoError("Photograph size should be less than 5MB");
      }
    }
  }


  const [aaderror, setAadError] = useState("");
  const [aadurl, setAadUrl] = useState("");
  const [afile, setAFile] = useState("");

  function aadfile(event) {
    setAadError("");
    setAFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setAadUrl(URL.createObjectURL(event.target.files[0]));
        setAFile(event.target.files[0]);
      } else {
        setAadError("Aadhar should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setAadError("Aadhar size should be less than 5MB");
      }
    }
  }

  const [flist, setFList] = useState([]);
  const [fpath, setFPath] = useState("");

  const [splist, setSPList] = useState([]);
  const [agecatlist, setAgeCatList] = useState([]);

  const [spclist, setSCList] = useState([]);

  useEffect(() => {
    if (localStorage.getItem("Role") === "1") {
      schoollist().then((response) => {
        if (response.status === true) {
          setSchList(response.data.details);
        }
      });
      sportsactivelist().then((response) => {
        if (response.status === true) {
          setSPList(response.data);
        }
      });
      profileagecatlist().then((response) => {
        if (response.status === true) {
          let arr = [];
          if (response.data.length !== 0) {
            for (let i = 0; i < response.data.length; i++) {
              arr.push({
                value: response.data[i].id,
                label: response.data[i].age_category_name,
              });
            }
          }
          setAgeCatList(arr);
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      schoolactivelistcityreg().then((response) => {
        if (response.status === true) {
          setSchList(response.data.details);
        }
      });

      crmsportslist().then((response) => {
        if (response.status === true) {
          setSPList(response.data);
        }
      });
      crmprofileagecatelist().then((response) => {
        if (response.status === true) {
          let arr = [];
          if (response.data.length !== 0) {
            for (let i = 0; i < response.data.length; i++) {
              arr.push({
                value: response.data[i].id,
                label: response.data[i].age_category_name,
              });
            }
          }
          setAgeCatList(arr);
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      schoollistmaster().then((response) => {
        if (response.status === true) {
          setSchList(response.data.details);
        }
      });
    }

    classlist().then((response) => {
      if (response.status === true) {
        setClassList(response.data);
      }
    });

    if (localStorage.getItem("Role") === "1") {
      viewprofile(id, new Date().getFullYear()).then((response) => {
        if (response.status === true) {
          setFName(response.data.playerlist.first_name);
          setDOB(response.data.playerlist.date_of_birth);
          setGender(response.data.playerlist.gender);

          if (response.data.playerlist.email_id !== null) {
            setEmail(response.data.playerlist.email_id);
          }
          if (response.data.playerlist.father_name !== null) {
            setFather(response.data.playerlist.father_name);
          }
          if (response.data.playerlist.mobile_no !== null) {
            setMobNo(response.data.playerlist.mobile_no);
          }
          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(response.data.playerlist.date_of_join);
          }

          setUser(response.data.playerlist.username);
          setStatus(response.data.playerlist.status);
          setSchool(response.data.playerlist.school_id);
          if (
            response.data.playerlist.class !== 0 &&
            response.data.playerlist.class !== null
          ) {
            setClass(response.data.playerlist.class);
          }
          setSection(response.data.playerlist.section);
          if (response.data.playerlist.photograph !== null) {
            setPhotoUrl(
              response.data.photo_path + response.data.playerlist.photograph
            );
          }
          if (response.data.playerlist.aadhar_image !== null) {
            setAadUrl(
              response.data.aadhar_path + response.data.playerlist.aadhar_image
            );
          }
          if (response.data.playerlist.sports_typeid !== null) {
            setSportId(response.data.playerlist.sports_typeid);
          }
          if (response.data.playerlist.sportsposition !== null) {
            setSportPos(response.data.playerlist.sportsposition);
          }
          if (response.data.playerlist.fq !== null) {
            setStuFQ(response.data.playerlist.fq);
          }
          if (response.data.playerlist.fq_bench_mark !== null) {
            setStuNFQ(response.data.playerlist.fq_bench_mark);
          }
          if (response.data.playerlist.sports_type !== null) {
            setSport(response.data.playerlist.sports_type);
          }
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      cityplayerview(id, new Date().getFullYear()).then((response) => {
        if (response.status === true) {
          setFName(response.data.playerlist.first_name);
          // setLName(response.data.playerlist.last_name);
          setDOB(response.data.playerlist.date_of_birth);
          setGender(response.data.playerlist.gender);
          if (response.data.playerlist.email_id !== null) {
            setEmail(response.data.playerlist.email_id);
          }
          if (response.data.playerlist.father_name !== null) {
            setFather(response.data.playerlist.father_name);
          }
          if (response.data.playerlist.mobile_no !== null) {
            setMobNo(response.data.playerlist.mobile_no);
          }
          setUser(response.data.playerlist.username);
          setStatus(response.data.playerlist.status);
          setSchool(response.data.playerlist.school_id);

          if (
            response.data.playerlist.class !== 0 &&
            response.data.playerlist.class !== null
          ) {
            setClass(response.data.playerlist.class);
          }
          setSection(response.data.playerlist.section);
          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(response.data.playerlist.date_of_join);
          }
          if (response.data.playerlist.photograph !== null) {
            setPhotoUrl(
              response.data.photo_path + response.data.playerlist.photograph
            );
          }
          if (response.data.playerlist.aadhar_image !== null) {
            setAadUrl(
              response.data.aadhar_path + response.data.playerlist.aadhar_image
            );
          }
          if (response.data.playerlist.sports_typeid !== null) {
            setSportId(response.data.playerlist.sports_typeid);
          }
          if (response.data.playerlist.sportsposition !== null) {
            setSportPos(response.data.playerlist.sportsposition);
          }
          if (response.data.playerlist.fq !== null) {
            setStuFQ(response.data.playerlist.fq);
          }
          if (response.data.playerlist.fq_bench_mark !== null) {
            setStuNFQ(response.data.playerlist.fq_bench_mark);
          }
          if (response.data.playerlist.sports_type !== null) {
            setSport(response.data.playerlist.sports_type);
          }
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      schoolviewplayer(id, new Date().getFullYear()).then((response) => {
        if (response.status === true) {
          setFName(response.data.playerlist.first_name);
          setDOB(response.data.playerlist.date_of_birth);
          setGender(response.data.playerlist.gender);
          if (response.data.playerlist.email_id !== null) {
            setEmail(response.data.playerlist.email_id);
          }
          if (response.data.playerlist.father_name !== null) {
            setFather(response.data.playerlist.father_name);
          }
          if (response.data.playerlist.mobile_no !== null) {
            setMobNo(response.data.playerlist.mobile_no);
          }
          setUser(response.data.playerlist.username);
          setStatus(response.data.playerlist.status);
          setSchool(response.data.playerlist.school_id);
          if (
            response.data.playerlist.class !== 0 &&
            response.data.playerlist.class !== null
          ) {
            setClass(response.data.playerlist.class);
          }
          setSection(response.data.playerlist.section);
          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(response.data.playerlist.date_of_join);
          }
          if (response.data.playerlist.photograph !== null) {
            setPhotoUrl(
              response.data.photo_path + response.data.playerlist.photograph
            );
          }
          if (response.data.playerlist.aadhar_image !== null) {
            setAadUrl(
              response.data.aadhar_path + response.data.playerlist.aadhar_image
            );
          }
          if (response.data.playerlist.sports_typeid !== null) {
            setSportId(response.data.playerlist.sports_typeid);
          }
          if (response.data.playerlist.sportsposition !== null) {
            setSportPos(response.data.playerlist.sportsposition);
          }
          if (response.data.playerlist.fq !== null) {
            setStuFQ(response.data.playerlist.fq);
          }
          if (response.data.playerlist.fq_bench_mark !== null) {
            setStuNFQ(response.data.playerlist.fq_bench_mark);
          }
          if (response.data.playerlist.sports_type !== null) {
            setSport(response.data.playerlist.sports_type);
          }
        }
      });
    }else if (localStorage.getItem("Role") === "7") {
      coachplayerview(id, new Date().getFullYear()).then((response) => {
        if (response.status === true) {
          setFName(response.data.playerlist.first_name);
          setDOB(response.data.playerlist.date_of_birth);
          setGender(response.data.playerlist.gender);
          if (response.data.playerlist.email_id !== null) {
            setEmail(response.data.playerlist.email_id);
          }
          if (response.data.playerlist.father_name !== null) {
            setFather(response.data.playerlist.father_name);
          }
          if (response.data.playerlist.mobile_no !== null) {
            setMobNo(response.data.playerlist.mobile_no);
          }
          setUser(response.data.playerlist.username);
          setStatus(response.data.playerlist.status);
          setSchool(response.data.playerlist.school_id);
          if (
            response.data.playerlist.class !== 0 &&
            response.data.playerlist.class !== null
          ) {
            setClass(response.data.playerlist.class);
          }
          setSection(response.data.playerlist.section);
          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(response.data.playerlist.date_of_join);
          }
          if (response.data.playerlist.photograph !== null) {
            setPhotoUrl(
              response.data.photo_path + response.data.playerlist.photograph
            );
          }
          if (response.data.playerlist.aadhar_image !== null) {
            setAadUrl(
              response.data.aadhar_path + response.data.playerlist.aadhar_image
            );
          }
          if (response.data.playerlist.sports_typeid !== null) {
            setSportId(response.data.playerlist.sports_typeid);
          }
          if (response.data.playerlist.sportsposition !== null) {
            setSportPos(response.data.playerlist.sportsposition);
          }
          if (response.data.playerlist.fq !== null) {
            setStuFQ(response.data.playerlist.fq);
          }
          if (response.data.playerlist.fq_bench_mark !== null) {
            setStuNFQ(response.data.playerlist.fq_bench_mark);
          }
          if (response.data.playerlist.sports_type !== null) {
            setSport(response.data.playerlist.sports_type);
          }
        }
      });
    }

    listform();
    listsportcate();
  }, []);

  function errorhandle(ev) {
    ev.target.src = require("../../../../assets/images/users.png");
    ev.target.onerror = null;
  }

  function backlist() {
    dotracking(
      "back button in edit player for " +
      fname +
      " (" +
      uname +
      " - " +
      id +
      ") $$ " +
      trackobj.playerdetheading
    );
    if (localStorage.getItem("Role") === "1") {
      if (localStorage.getItem("PEdit") == 2) {
        navigate("/superadmin/tournamentplayer/" + id);
      } else {
        navigate("/superadmin/viewplayer/" + id);
      }
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/viewplayer/" + id);
    }
  }
  function submitplayer(e) {
    e.preventDefault();
    setSubmitted(true);
    setEmailErr("");
    setMobErr("");
    var valid = "";

    if (email !== "") {
      let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      if (!regEmail.test(email)) {
        valid = "required";
        setEmailErr("Please Enter a valid Email Address");
      }
    }
    if (mobno !== "") {
      if (mobno.length !== 10) {
        valid = "required";
        setMobErr("Mobile Number must be 10 characters");
      }
    }
    if (
      fname !== "" &&
      gender !== "" &&
      dob !== "" &&
      // email !== "" &&
      // mobno !== "" &&
      clas !== "" &&
      section !== "" &&
      schid !== "" &&
      valid === ""
    ) {
      dotracking(
        "update button in edit player for " +
        fname +
        " (" +
        id +
        ") $$ " +
        trackobj.playerdetheading
      );
      setLoading(true);
      const temp = new FormData();
      temp.append("email_id", email);
      temp.append("mobile_no", mobno);
      temp.append("first_name", fname);
      temp.append("last_name", "");
      temp.append("gender", gender);
      temp.append("date_of_birth", dob);
      temp.append("school_id", schid);
      temp.append("class", clas);
      temp.append("section", section);
      temp.append("father_name", father);
      temp.append("user_id", id);
      temp.append("photograph", photo);
      temp.append("position", sportpos);
      temp.append("sports_pos_id", 0);
      temp.append("sports_typeid", sportid);
      temp.append("sports", sport);
      temp.append("fq", stufq);
      temp.append("fq_bench_mark", stunfq);
      temp.append("active_or_passive", pstatus);
      temp.append("date_of_join", doj);
      temp.append("aadhar_image", afile);

      if (localStorage.getItem("Role") === "1") {
        adminupdateplayer(temp).then((response) => {
          if (response.status === true) {
            setLoading(false);
            toast.success(response.message);
            if (localStorage.getItem("PEdit") == 2) {
              navigate("/superadmin/tournamentplayer/" + id);
            } else {
              navigate("/superadmin/viewplayer/" + id);
            }
            // if (status === 1) {
            //   navigate("/superadmin/allplayers");
            // } else if (status === 6) {
            //   navigate("/superadmin/blockedplayers");
            // }
          } else {
            setLoading(false);
            setErrorMsg(response.message);
          }
        });
      } else if (localStorage.getItem("Role") === "3") {
        cityupdateplayer(temp).then((response) => {
          if (response.status === true) {
            setLoading(false);
            toast.success(response.message);
            navigate("/cityregional/viewplayer/" + id);
            // if (status === 1) {
            //   navigate("/superadmin/allplayers");
            // } else if (status === 6) {
            //   navigate("/superadmin/blockedplayers");
            // }
          } else {
            setLoading(false);
            setErrorMsg(response.message);
          }
        });
      }else if (localStorage.getItem("Role") === "4") {
        schupdateplayer(temp).then((response) => {
          if (response.status === true) {
            setLoading(false);
            toast.success(response.message);
            navigate("/schoolhead/viewplayer/" + id);
          } else {
            setLoading(false);
            setErrorMsg(response.message);
          }
        });
      }else if (localStorage.getItem("Role") === "7") {
        coachupdateplayer(temp).then((response) => {
          if (response.status === true) {
            setLoading(false);
            toast.success(response.message);
            navigate("/coach/viewplayer/" + id);
          } else {
            setLoading(false);
            setErrorMsg(response.message);
          }
        });
      }else {
        setLoading(false);
      }
    }
  }
  const [emailerr, setEmailErr] = useState("");
  function checkemail(e) {
    e.preventDefault();
    setEmailErr("");
    if (e.target.value !== "") {
      let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      if (!regEmail.test(e.target.value)) {
        setEmailErr("Please Enter a valid Email Address");
      }
    }
  }

  const [moberr, setMobErr] = useState("");
  function checkmob(e) {
    e.preventDefault();
    setMobErr("");
    if (e.target.value !== "") {
      if (e.target.value.length !== 10) {
        setMobErr("Mobile Number must be 10 characters");
      }
    }
  }

  const [loading, setLoading] = useState(false);

  const [rows, setRows] = useState([
    { fname: "", fdesc: "", cform: "", certerr: "" },
  ]);

  const handleAddRow = () => {
    setRows([...rows, { fname: "", fdesc: "", cform: "", certerr: "" }]);
  };

  const handleRemoveRow = (index) => {
    setRows(rows.filter((_, i) => i !== index));
  };

  const handleDescChange = (index, e) => {
    const updatedRows = [...rows];
    updatedRows[index].fdesc = e.target.value;
    setRows(updatedRows);
  };

  const handleInputChange = (index, e) => {
    const updatedRows = [...rows];
    updatedRows[index].fname = e.target.value;
    setRows(updatedRows);
  };

  const handleFileChange = (index, e) => {
    const updatedRows = [...rows];
    updatedRows[index].certerr = "";
    updatedRows[index].cform = "";
    setRows(updatedRows);
    if (e.target.files.length !== 0) {
      if (e.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        updatedRows[index].cform = e.target.files[0];
        setRows(updatedRows);
      } else {
        updatedRows[index].cform = "";
        updatedRows[index].certerr = "Form should be jpg or png or jpeg format";
        setRows(updatedRows);
      }
      var size = e.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        updatedRows[index].certerr = "Form size should be less than 5MB";
        setRows(updatedRows);
      }
    }
  };

  const [formsubmit, setFormsubmit] = useState(false);
  function submitform(e) {
    e.preventDefault();
    setFormsubmit(true);
    const isName = rows.every((row) => row.fname !== "");
    const isFile = rows.every((row) => row.cform !== "");
    const isDesc = rows.every((row) => row.fdesc !== "");
    const isError = rows.every((row) => row.certerr === "");

    if (isName && isFile && isDesc && isError) {
      setLoading(true);
      const temp = new FormData();
      temp.append("user_id", id);
      temp.append("admin_id", localStorage.getItem("UID"));
      temp.append("form_count", rows.length);
      for (let i = 0; i < rows.length; i++) {
        temp.append("form_name_" + [i + 1], rows[i].fname);
        temp.append("form_description_" + [i + 1], rows[i].fdesc);
        temp.append("form_image_" + [i + 1], rows[i].cform);
      }
      dotracking(
        "upload registration form in edit player for " +
        fname +
        " (" +
        uname +
        " - " +
        id +
        ") $$ " +
        trackobj.editplayerheading
      );
      playerformupload(temp).then((res) => {
        if (res.status === true) {
          setLoading(false);
          setFormsubmit(false);
          toast.success(res.message);
          if (localStorage.getItem("Role") === "1") {
            if (localStorage.getItem("PEdit") == 2) {
              navigate("/superadmin/tournamentplayer/" + id);
            } else {
              navigate("/superadmin/viewplayer/" + id);
            }

          } else if (localStorage.getItem("Role") === "3") {
            navigate("/cityregional/viewplayer/" + id);
          }
        } else {
          setLoading(false);
          setFormsubmit(false);
          setErrorMsg(res.message);
        }
      });
    }
  }

  const [rname, setRName] = useState("");
  const [rdesc, setRDesc] = useState("");
  const [rfile, setRFile] = useState("");
  const [show, setShow] = useState(false);

  function handlepop(fname, fdesc, ffile) {
    setRName(fname);
    setRDesc(fdesc);
    setRFile(fpath + ffile);
    setShow(true);
  }

  function imageclose() {
    setShow(false);
    setRName("");
    setRDesc("");
    setRFile("");
  }

  function deleteform(did) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete registration form in edit player for " +
          fname +
          " (" +
          uname +
          " - " +
          id +
          ") $$ " +
          trackobj.editplayerheading
        );
        playerformdelete(did).then((response) => {
          if (response.status === true) {
            listform();
            toast.success(response.message);
          }
        });
      }
    });
  }

  function listform() {
    setFList([]);
    playerformlist(id).then((res) => {
      if (res.status === true) {
        setFList(res.data.form_images);
        setFPath(res.data.form_path);
      }
    });
  }

  const [sprows, setSpRows] = useState([{ psport: "", pcate: "", psub: "" }]);
  const handleAddSport = () => {
    setSpRows([...sprows, { psport: "", pcate: "", psub: "" }]);
  };

  const handleRemoveSport = (index) => {
    setSpRows(sprows.filter((_, i) => i !== index));
  };

  const handleSportChange = (index, e) => {
    const updatedRows = [...sprows];
    updatedRows[index].psport = e.target.value;
    setSpRows(updatedRows);
  };

  const handleCateChange = (index, e) => {
    const updatedRows = [...sprows];
    updatedRows[index].pcate = e;
    setSpRows(updatedRows);
  };

  const handleSubCatChange = (index, e) => {
    const updatedRows = [...sprows];
    updatedRows[index].psub = e.target.value;
    setSpRows(updatedRows);
  };

  const [spsubmit, setSpsubmit] = useState(false);
  function submitsport(e) {
    e.preventDefault();
    setSpsubmit(true);
    const isSport = sprows.every((row) => row.psport !== "");
    const isCate = sprows.every((row) => row.pcate !== "");
    const isSub = sprows.every((row) => row.psub !== "");

    if (isSport && isCate && isSub) {
      setLoading(true);
      const temp = new FormData();
      temp.append("user_id", id);
      temp.append("admin_id", localStorage.getItem("UID"));
      temp.append("sports_count", sprows.length);
      for (let i = 0; i < sprows.length; i++) {
        temp.append("sports_id_" + [i + 1], sprows[i].psport);
        temp.append("category_id_" + [i + 1], sprows[i].pcate.value);
        temp.append("sub_category_name_" + [i + 1], sprows[i].psub);
      }
      dotracking(
        "upload sports category in edit player for " +
        fname +
        " (" +
        uname +
        " - " +
        id +
        ") $$ " +
        trackobj.editplayerheading
      );
      playersportcateupload(temp).then((res) => {
        if (res.status === true) {
          setSpsubmit(false);
          setLoading(false);
          toast.success(res.message);
          if (localStorage.getItem("Role") === "1") {
            if (localStorage.getItem("PEdit") == 2) {
              navigate("/superadmin/tournamentplayer/" + id);
            } else {
              navigate("/superadmin/viewplayer/" + id);
            }
          } else if (localStorage.getItem("Role") === "3") {
            navigate("/cityregional/viewplayer/" + id);
          }
        } else {
          setLoading(false);
          setSpsubmit(false);
          setErrorMsg(res.message);
        }
      });
    }
  }

  function listsportcate() {
    setSCList([]);
    playersportcatelist(id).then((res) => {
      if (res.status === true) {
        setSCList(res.data.form_images);
      }
    });
  }

  function deletesportcate(did) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete sports category in edit player for " +
          fname +
          " (" +
          uname +
          " - " +
          id +
          ") $$ " +
          trackobj.editplayerheading
        );
        playersportcatedelete(did).then((response) => {
          if (response.status === true) {
            listsportcate();
            toast.success(response.message);
          }
        });
      }
    });
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Player Detail</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Player</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Player Detail
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-12">
          <form className="card mt-0">
            {loading && (
              <div className="dashloader-wrapper">
                <div className="loader"></div>
                <h3>Loading...Please do not go back or close the window.</h3>
              </div>
            )}

            {!loading && (
              <>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Full Name <span className="errortext"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Full Name"
                          value={fname}
                          onChange={(e) => setFName(e.target.value)}
                          autoFocus
                          onKeyPress={LetterOnly}
                          onPaste={onPasteLetter}
                        />
                        {submitted && !fname && (
                          <span className="errortext">
                            Full Name is required
                          </span>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label">
                      Last Name <span className="errortext"> *</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last Name"
                      value={lname}
                      onChange={(e) => setLName(e.target.value)}
                      onKeyPress={LetterOnly}
                      onPaste={onPasteLetter}
                    />
                    {submitted && !lname && (
                      <span className="errortext">Last Name is required</span>
                    )}
                  </div>
                </div> */}

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Gender <span className="errortext"> *</span>
                        </label>
                        <select
                          value={gender}
                          className="form-control"
                          onChange={(e) => setGender(e.target.value)}
                        >
                          <option value="" defaultValue disabled>
                            --- Select Gender ---
                          </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                        {submitted && !gender && (
                          <span className="errortext">Gender is required</span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Date of Birth <span className="errortext"> *</span>
                        </label>
                        <input
                          type="date"
                          value={dob}
                          className="form-control"
                          onChange={(e) => setDOB(e.target.value)}
                          onKeyPress={(event) => {
                            event.preventDefault();
                          }}
                          onKeyDown={(event) => {
                            event.preventDefault();
                          }}
                        />
                        {submitted && !dob && (
                          <span className="errortext">
                            Date of Birth is required
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Email Address
                          {/* <span className="errortext"> *</span> */}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Email Address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          onBlur={checkemail}
                        />
                        {/* {submitted && !email && (
                          <span className="errortext">
                            Email Address is required
                          </span>
                        )} */}
                        {emailerr !== "" && (
                          <span className="errortext">{emailerr}</span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Mobile Number
                          {/* <span className="errortext"> *</span> */}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Mobile Number"
                          value={mobno}
                          onChange={handleChange}
                          onBlur={checkmob}
                          maxLength={10}
                          onPaste={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          onCopy={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                        />
                        {/* {submitted && !mobno && (
                          <span className="errortext">
                            Mobile Number is required
                          </span>
                        )} */}
                        {moberr !== "" && (
                          <span className="errortext">{moberr}</span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">School </label>
                        <select
                          className="form-control"
                          value={schid}
                          onChange={(e) => setSchool(e.target.value)}
                          disabled={
                            localStorage.getItem("Role") === "4" ? true : false
                          }
                        >
                          <option value="" defaultValue disabled>
                            --- Select School ---
                          </option>
                          {schlist.map((data, i) => {
                            return (
                              <option value={data.id} key={i}>
                                {data.school_unique_no} - {data.school_name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Class <span className="errortext"> *</span>
                        </label>
                        <select
                          value={clas}
                          className="form-control"
                          onChange={(e) => setClass(e.target.value)}
                        >
                          <option value="" defaultValue disabled>
                            --- Select Class ---
                          </option>
                          {sclist.map((data, i) => {
                            return (
                              <option value={data.id} key={i}>
                                {data.class}
                              </option>
                            );
                          })}
                        </select>
                        {submitted && !clas && (
                          <span className="errortext">Class is required</span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Section <span className="errortext"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Section"
                          value={section}
                          onChange={(e) => setSection(e.target.value)}
                          //   onKeyPress={LetterOnly}
                          onPaste={onPasteLetter}
                        />
                        {submitted && !section && (
                          <span className="errortext">Section is required</span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Father Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Father Name"
                          value={father}
                          onChange={(e) => setFather(e.target.value)}
                          onKeyPress={LetterOnly}
                          onPaste={onPasteLetter}
                        />

                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Active or Passive</label>
                        <select
                          value={pstatus}
                          className="form-control"
                          onChange={(e) => setPStatus(e.target.value)}
                        >
                          <option value="" defaultValue disabled>
                            --- Select Active or Passive ---
                          </option>
                          <option value="1">Active</option>
                          <option value="2">Passive</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Date of Joining</label>
                        <input
                          type="date"
                          value={doj}
                          className="form-control"
                          onChange={(e) => setDOJ(e.target.value)}
                          onKeyPress={(event) => {
                            event.preventDefault();
                          }}
                          onKeyDown={(event) => {
                            event.preventDefault();
                          }}
                        />
                      </div>
                    </div>
</div>
<div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Photograph
                          {/* <span className="errortext"> *</span> */}
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".jpg,.jpeg,.png"
                          onChange={photofile}
                        />
                        <img
                          className="profile_img mt-2"
                          src={photourl}
                          height="160"
                          alt="photo"
                          onError={(e) => errorhandle(e)}
                        />

                        {/* {submitted && !photo && (
                          <span className="errortext">
                            Photograph is required
                          </span>
                        )} */}
                        {photoerror !== "" && (
                          <span className="errortext">{photoerror}</span>
                        )}
                      </div>
                    </div>
                     <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Aadhar
                          {/* <span className="errortext"> *</span> */}
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".jpg,.jpeg,.png"
                          onChange={aadfile}
                        />
                        <img
                          className="profile_img mt-2"
                          src={aadurl}
                          height="160"
                          alt="photo"
                          onError={(e) => errorhandle(e)}
                        />

                        {/* {submitted && !photo && (
                          <span className="errortext">
                            Photograph is required
                          </span>
                        )} */}
                        {aaderror !== "" && (
                          <span className="errortext">{aaderror}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  {errorMsg !== "" && (
                    <span className="errortext">{errorMsg}</span>
                  )}
                  <div className="text-right mt-2">
                    <button
                      type="submit"
                      className="btn btn-gray me-2"
                      title="Player List"
                      onClick={backlist}
                    >
                      Back
                    </button>

                    <button
                      type="submit"
                      className="btn btn-success"
                      title="Update Player"
                      onClick={submitplayer}
                    >
                      Update
                    </button>
                  </div>
                  {/* <hr />
                  <h4>Sports Category Details</h4>
                  <div className="details-group refereebox deletereferee">
                    <div className="row">
                      {spclist.map((data, i) => {
                        return (
                          <div className="col-md-3 align-self-center" key={i}>
                            <div className="form-group">
                              <h4 className="mb-1">{data.sports_category}</h4>
                              <h4 className="text-gray mb-0">
                                {data.age_category_name}
                              </h4>
                              <h5 className="text-success mb-0">
                                {data.sub_category_name}
                              </h5>
                              <a
                                className="deleterefer"
                                onClick={() => deletesportcate(data.id)}
                              >
                                <i className="fa fa-close"></i>
                              </a>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div> 
                  {sprows.map((row, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="form-label">
                            Sports <span className="errortext"> *</span>
                          </label>
                          <select
                            className="form-control custom-select"
                            value={row.psport}
                            onChange={(e) => handleSportChange(index, e)}
                          >
                            <option value="" defaultValue disabled>
                              --- Select Sports ---
                            </option>
                            {splist.map((data, i) => {
                              return (
                                <option value={data.sports_cat_uid} key={i}>
                                  {data.sports_category}
                                </option>
                              );
                            })}
                          </select>
                          {spsubmit && !row.psport && (
                            <span className="errortext">Sport is required</span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="form-label">
                            Category <span className="errortext"> *</span>
                          </label>

                          <Select
                            className="dropdown"
                            placeholder="Select Age Categories"
                            value={row.pcate}
                            options={agecatlist}
                            onChange={(e) => handleCateChange(index, e)}
                            isSearchable={true}
                            isClearable
                            hidden
                          />

                          {spsubmit && !row.pcate && (
                            <span className="errortext">
                              Category is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="form-label">
                            Sub Category <span className="errortext"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Sub Category"
                            value={row.psub}
                            onChange={(e) => {
                              handleSubCatChange(index, e);
                            }}
                          />

                          {spsubmit && !row.psub && (
                            <span className="errortext">
                              Sub Category is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-2 text-right mt-6">
                        {index == 0 && (
                          <a
                            className="btn-sm btn-success"
                            onClick={handleAddSport}
                          >
                            <i className="fa fa-plus fa-lg"></i>
                          </a>
                        )}
                        {index != 0 && (
                          <a
                            className="btn-sm btn-danger"
                            onClick={() => handleRemoveSport(index)}
                          >
                            <i className="fa fa-trash fa-lg"></i>
                          </a>
                        )}
                      </div>
                    </div>
                  ))}
                  <hr />
                  <div className="text-right">
                    <button
                      type="submit"
                      className="btn btn-success"
                      onClick={submitsport}
                    >
                      Submit Sports
                    </button>
                  </div>*/}
                  <h4>Registration Form Details</h4>
                  <div className="row">
                    {flist.map((item, index) => {
                      return (
                        <div className="col-lg-3 col-md-3" key={index}>
                          <div className="services-three__card">
                            <div className="photores-download">
                              <a onClick={() => deleteform(item.id)}>
                                <i className="fa fa-trash fa-lg"></i>
                              </a>
                            </div>

                            <a
                              className="services-three__card__image"
                              onClick={() =>
                                handlepop(
                                  item.form_name,
                                  item.form_description,
                                  item.form_file
                                )
                              }
                            >
                              <img
                                src={fpath + item.form_file}
                                width="150px"
                                height="150px"
                                alt="business loan"
                              />
                              <img
                                src={fpath + item.form_file}
                                width="150px"
                                height="150px"
                                alt="business loan"
                              />
                              <span className="services-three__card__overlay"></span>
                            </a>

                            <div className="services-one__card__content">
                              <h4 className="text-success">{item.form_name}</h4>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {rows.map((row, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="form-label">
                            Name <span className="errortext"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            value={row.fname}
                            onChange={(e) => handleInputChange(index, e)}
                          />
                          {formsubmit && !row.fname && (
                            <span className="errortext">Name is required</span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="form-label">
                            Description <span className="errortext"> *</span>
                          </label>
                          <textarea
                            rows="2"
                            className="form-control"
                            placeholder="Enter Description"
                            value={row.fdesc}
                            onChange={(e) => handleDescChange(index, e)}
                          />
                          {formsubmit && !row.fdesc && (
                            <span className="errortext">
                              Description is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="form-label">
                            Form <span className="errortext"> *</span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => handleFileChange(index, e)}
                          />
                          {formsubmit && !row.cform && row.certerr === "" && (
                            <span className="errortext">Form is required</span>
                          )}
                          {formsubmit && row.certerr !== "" && (
                            <span className="errortext">{row.certerr}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-1 col-lg-1 text-right mt-6">
                        {index == 0 && (
                          <a
                            className="btn-sm btn-success"
                            onClick={handleAddRow}
                          >
                            <i className="fa fa-plus fa-lg"></i>
                          </a>
                        )}
                        {index != 0 && (
                          <a
                            className="btn-sm btn-danger"
                            onClick={() => handleRemoveRow(index)}
                          >
                            <i className="fa fa-trash fa-lg"></i>
                          </a>
                        )}
                      </div>
                    </div>
                  ))}
                  <div className="text-right">
                    <button
                      type="submit"
                      className="btn btn-success"
                      onClick={submitform}
                    >
                      Submit Form
                    </button>
                  </div>
                </div>
              </>
            )}

            <Modal show={show} size="lg">
              <Modal.Header>
                <h4> Registration Form</h4>
              </Modal.Header>
              <Modal.Body>
                <Row className="row-sm mx-0">
                  <Col lg={12} md={12}>
                    <div className="form-group">
                      <img src={rfile} alt="Photo" width="100%" />
                    </div>
                  </Col>

                  <Col lg={12} md={12}>
                    <div className="form-group">
                      <h4>{rname}</h4>
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="form-group">
                      <p>{rdesc}</p>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <a className="btn btn-danger" onClick={imageclose}>
                  Close
                </a>
              </Modal.Footer>
            </Modal>
          </form>
        </div>
      </div>
    </div>
  );
};
